import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '@app/services';

@Component({
  selector: 'app-login',
  template: '<p>Logging in to QualityBidders...</p>',
  // templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private login: LoginService,
    private route: ActivatedRoute
  ) {}

  // Upon loading this page, redirect to the login page.
  // If we specify a target in the query params, redirect to that page after we finish logging in.
  ngOnInit(): void {
    this.route.queryParams.subscribe(val => {
      let target = val[0] ?? '/';
      target = target[0] === '/' ? '/' + target : target;
      this.login.login(target);
    });
  }
}
